var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { attrs: { id: "front-videos" } }, [
    _c(
      "section",
      { staticClass: "video-descriptions" },
      [
        _c("p", [
          _vm._v(
            "Here is a sampling of the many great programs and services Overlake has to offer:"
          ),
        ]),
        _vm._v(" "),
        _vm._l(_vm.videos, function (video, i) {
          return _c("div", {
            key: i,
            domProps: { innerHTML: _vm._s(video.description) },
          })
        }),
      ],
      2
    ),
    _vm._v(" "),
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      { attrs: { id: "controls" } },
      [
        _c("div", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showInfo,
              expression: "showInfo",
            },
          ],
          staticClass: "shadow",
          attrs: { id: "video-info" },
          domProps: { innerHTML: _vm._s(_vm.description) },
        }),
        _vm._v(" "),
        _c("font-awesome-icon", {
          staticClass: "shadow",
          attrs: {
            id: "btn-pause",
            icon: _vm.paused ? _vm.iconPlay : _vm.iconPause,
          },
        }),
        _vm._v(" "),
        _c("font-awesome-icon", {
          staticClass: "shadow",
          attrs: { id: "btn-info", icon: _vm.iconInfo },
          on: { click: _vm.toggleInfo },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { attrs: { id: "videos" } },
      [
        _c(
          "div",
          { attrs: { id: "paused" } },
          [
            _c("font-awesome-icon", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.paused,
                  expression: "paused",
                },
              ],
              staticClass: "shadow",
              attrs: { icon: _vm.iconPlay },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _vm._l(_vm.videos, function (video, index) {
          return _c("Video", {
            key: "video-" + index,
            ref: "video-" + index,
            refInFor: true,
            attrs: { index: index, video: video, "top-index": _vm.topIndex },
            on: { ended: _vm.switchVideos },
          })
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("a", { attrs: { href: "/about" } }, [
      _c("img", {
        staticClass: "shadow",
        attrs: {
          id: "logo-front",
          src: "https://www.overlake.org/sites/default/files/pictures/branding/logo-front.png",
          alt: "About the Overlake School",
        },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }